const UI_PERMISSIONS_NAME = {
    ViewRootDomain: "View Root Domain Settings",
    EditRootDomain: "Edit Root Domain",
    CreateDomains: "Create Domains",
    ViewUsers: "View Users",
    EditUsers: "Edit Users",
    ViewDomain: "View Domain Settings",
    EditDomain: "Edit Domain",
    ViewEnvironments: "View Environments",
    EditEnvironments: "Edit Environments",
    CreateDeployment: "Create Deployment",
    ViewDeployment: "View Deployment",
    EditDeployment: "Edit Deployment",
    ViewBuildtime: "View Buildtime Config",
    EditBuildtime: "Edit Buildtime Config",
    ViewRuntime: "View Runtime Config",
    EditRuntime: "Edit Runtime Config",
    ViewSyncLogs: "View Sync Logs",
    Notifications: "Notifications",
};

export default UI_PERMISSIONS_NAME;
